import React from "react";
import {
  Create,
  SimpleForm,
  SelectInput,
  CreateProps,
  FormDataConsumer,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import { typeList } from "./conts";
import AllDaysOfWeekInput from "components/AllDaysOfWeekInput";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import CustomEndDateInput from "components/CustomEndDateInput";
import RouteInput from "./components/RouteInput";
import StudentInput from "./components/StudentInput";
import WaveInput from "./components/WaveInput";

const NotTakingCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Exclude Students", link: "/notTakingStudents" },
    { title: "Create", link: "/notTakingStudents/create" },
  ];

  const transform = async (data: any) => {
    if (data.type === "day") {
      data.period = null;

      data.isMonday = data.isMonday ? true : false;
      data.isTuesday = data.isTuesday ? true : false;
      data.isWednesday = data.isWednesday ? true : false;
      data.isThursday = data.isThursday ? true : false;
      data.isFriday = data.isFriday ? true : false;
      data.isSaturday = data.isSaturday ? true : false;
      data.isSunday = data.isSunday ? true : false;
    }

    if (data.type === "date") {
      data.period = {
        start: data.startDate,
        end: data.endDate,
      };

      delete data.startDate;
      delete data.endDate;

      data.isMonday = false;
      data.isTuesday = false;
      data.isWednesday = false;
      data.isThursday = false;
      data.isFriday = false;
      data.isSaturday = false;
      data.isSunday = false;
    }

    return data;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New Exclude Student</Typography>
      <Create {...props} transform={transform}>
        <SimpleForm toolbar={<CustomCreateToolbar directAction="list" />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Route Plan</Typography>
            </Grid>
            <Grid item xs={4}>
              <WaveInput />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Route </Typography>
            </Grid>
            <Grid item xs={4}>
              <RouteInput />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={4}>
              <StudentInput />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Not Taking Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <SelectInput source="type" choices={typeList} />
            </Grid>
            <Grid item xs={8}></Grid>

            <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.type === "day" ? (
                  <>
                    <AllDaysOfWeekInput />
                  </>
                ) : (
                  formData.type === "date" && (
                    <>
                      <Grid item xs={4}>
                        <CustomDatePickerInput
                          name="startDate"
                          label="Start Date"
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <CustomEndDateInput
                          source="endDate"
                          label="End Date"
                          comparison="startDate"
                        />
                      </Grid>
                      <Grid item xs={4}></Grid>
                    </>
                  )
                )
              }
            </FormDataConsumer>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default NotTakingCreate;
